module.exports = __webpack_public_path__ + "img/kdLogo_CH.53a2fc47.svg";